<template>
  <calm-page extra-class="billrep" :title="$t('menu.billing')" :stats="stats">
    <!-- ═══════════════ SEARCH BAR (date range) ═══════════════ -->
    <calm-filter-bar
      :loading="isLoading"
      :search-label="$t('search')"
      :reset-label="$t('searchall')"
      @search="listData(searchParams)"
      @reset="listData({ start_date: '', end_date: '' })"
    >
      <calm-field :label="$t('lmg.due_date')">
        <flat-picker
          :config="{ allowInput: true }"
          class="form-control datepicker"
          v-model="searchParams.start_date"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.due_date')">
        <flat-picker
          :config="{ allowInput: true }"
          class="form-control datepicker"
          v-model="searchParams.end_date"
        >
        </flat-picker>
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <template slot="toolbar">
        <calm-field :label="$t('search')">
          <input
            v-model="searchQuery"
            type="text"
            class="ed"
            :placeholder="$t('search')"
          />
        </calm-field>
      </template>

      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column :label="$t('lmg.due_date')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.due_date }}
          </template>
        </el-table-column>

        <el-table-column label="จ่ายแล้ว" min-width="200">
          <template slot-scope="{ row }">
            {{ row.paid }}
          </template>
        </el-table-column>

        <el-table-column label="ยังไม่ได้จ่าย" min-width="200">
          <template slot-scope="{ row }">
            {{ row.not_paid }}
          </template>
        </el-table-column>

        <el-table-column label="ไม่ได้สร้างใบวางบิล" min-width="200">
          <template slot-scope="{ row }">
            {{ row.not_create_invoice }}
          </template>
        </el-table-column>

        <el-table-column :label="$t(`actions`)" min-width="200px" align="right">
          <div slot-scope="{ row }" class="billrep__rowact">
            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleDetail(row)"
            >
              <i class="fa fa-list"></i>
            </calm-button>
          </div>
        </el-table-column>
      </el-table>
    </calm-table>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
		tableData: "Billing/getDataDueDate",
		isLoading: "Billing/isLoadingDuedate",
    }),
    // Additive summary cards: sum the numeric value of each status column over
    // every row (strip thousands-commas, coerce to Number). Display-only; does
    // not alter any existing data/store/method.
    stats() {
      const sum = key =>
        (this.tableData || []).reduce((acc, row) => {
          const raw = String(row[key] == null ? 0 : row[key]).replace(/,/g, "");
          const n = Number(raw);
          return acc + (isNaN(n) ? 0 : n);
        }, 0);
      const fmt = v =>
        this.FormatCurrency ? this.FormatCurrency(v) : v;
      return [
        { key: "paid", label: "จ่ายแล้ว", value: fmt(sum("paid")), variant: "success" },
        { key: "not_paid", label: "ยังไม่ได้จ่าย", value: fmt(sum("not_paid")), variant: "warning" },
        { key: "not_create_invoice", label: "ไม่ได้สร้างใบวางบิล", value: fmt(sum("not_create_invoice")), variant: "danger" }
      ];
    }
  },
  data() {
    return {
      propsToSearch: ["Name", "AcountNumber"],
      selectedRows: [],
      showAddModal: false,
      showImageModal: false,
      showTransactionDetailModal : false,
      searchParams: {
        start_date: "",
        end_date: "",

      },
      detail: {},

    };
  },
  async mounted() {
    await this.listData(this.searchParams);
  },
  methods: {
    ...mapActions({
      listData: "Billing/listBillingDuedate",
    }),
	handleDetail(row){
		this.$router.push({
			name:'billingreportDetailList',
			params: {
				due_date : row.due_date,
				datas : row.detail
			}
		})
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.md.billfile = files[0];
    }
  }
};
</script>
<style scoped>
/* Billing-report (due-date summary) — Calm skin. Namespaced under .billrep so
   nothing leaks. The el-table is kept verbatim (§11 "skin, don't rewrite") and
   re-styled only via deep selectors below. */

/* Row-action cell: keep the icon button right-aligned. */
.billrep__rowact {
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
}

/* The free-text search box reuses the Kit's .ed input look. */
.billrep >>> .ed {
  width: 100%;
}

/* Skin the existing <el-table> as a Calm surface — deep selectors only,
   no column/slot changes (§11). */
.billrep >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.billrep >>> .el-table th,
.billrep >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.billrep >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.billrep >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.billrep >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
